module.exports = __webpack_public_path__ + "media/auto_history/pierwszy_wlasciciel-blue-b73242d0.svg";